export class ClaEvents {
  static readonly NAV_WELCOME: string = 'nav:welcome';
  static readonly NAV_WALKTHROUGH: string = 'nav:walkthrough';
  static readonly NAV_CONTINUE_ONBOARD: string = 'nav:continueonboard';
  static readonly NAV_CONTINUE_BLUETOOTH: string = 'nav:continuebluetooth';
  static readonly NAV_GO_HOME: string = 'nav:home';
  static readonly NAV_GO_SETTINGS: string = 'nav:settings';
  static readonly NAV_GO_CHANGEWIFI: string = 'nav:changewifi';
  static readonly NAV_WALKTHROUGH_COMPLETE: string = 'walkthrough:complete';
  static readonly NAV_APP_ROOT: string = 'nav:approot';
  static readonly ONBOARD_COMPLETE: string = 'onboard:complete';
  static readonly ONBOARD_AZURE_SUCCESS: string = 'onboardazure:connected';
  static readonly MODAL_BOX_STATUS: string = 'modal:boxstatus';
  static readonly MODAL_BOX_SELECT: string = 'modal:boxselect';
  static readonly ALERT_OFFLINE_EXPIRED: string = 'alert:offlineexpired';
  static readonly ALERT_OFFLINE_FAILED: string = 'alert:offlinefailed';
  static readonly OFFLINE_CONNECTING: string = 'offline:connecting';
  static readonly OFFLINE_CONNECTING_COMPLETE: string = 'offline:connectingcomplete';
  static readonly TOAST_WARNING: string = 'toast:warning';
  static readonly TOAST_HIDE: string = 'toast:hide';
  static readonly BOX_DISCONNECT: string = 'box:disconnect';
  static readonly BOX_STATUS_CHANGE: string = 'box:statuschange';
  static readonly LOGIN_STATUS_CHANGE: string = 'login:statuschange';
  static readonly APP_RESUME: string = 'app:resume';
  static readonly APP_PAUSE: string = 'app:pause';
  static readonly CALIBRATION_RESULT: string = 'calibration:result';
  static readonly CALIBRATIONCOMPLETE_RESULT: string = 'calibrationcomplete:result';
  static readonly CALIBRATION_MESSAGE: string = 'calibration:message';
  static readonly SCANDATA_THERMAL_RX: string = 'scandata:thermal:rx';
  static readonly SCANDATA_THERMAL_ROLLINGCOMPLETE: string = 'scandata:thermal:rollingcomplete';
  static readonly SCANDATA_THERMAL_SEGMENTALCOMPLETE: string = 'scandata:thermal:segmentalcomplete';
  static readonly SCANDATA_THERMAL_SPEED: string = 'scandata:thermal:speed';
  static readonly SCANDATA_EMG_RX: string = 'scandata:emg:rx';
  static readonly SCANDATA_EMG_STANDARD: string = 'scandata:emg:standard';
  static readonly SCANDATA_EMG_POSITION: string = 'scandata:emg:position';
  static readonly SCANDATA_HRV_RX: string = 'scandata:hrv:rx';
  static readonly SCANDATA_HRV_COMPLETE: string = 'scandata:hrv:complete';
  static readonly SCANDATA_ROM_RX: string = 'scandata:rom:rx';
  static readonly SCANDATA_ALGO_RX: string = 'scandata:algo:rx';
  static readonly SCANDATA_ALGO_COMPLETE: string = 'scandata:algo:complete';
  static readonly RAWDATA: string = 'rawdata:any';
  static readonly POWER_LEVEL: string = 'power:level';
  static readonly EXAM_SELECT_PATIENT: string = 'exam:patient';
  static readonly FIRMWARE_PROGRESS: string = 'firmware:progress';
  static readonly BOX_CONNECT_ERROR: string = 'box:connect:error';
  static readonly EMG_CONNECTED: string = 'emg:connected';
  static readonly EMG_LISTENING: string = 'emg:listening';
  static readonly EMG_STATUS_RX: string = 'emg:status:rx';
  static readonly EMG_CONFIG_RX: string = 'emg:config:rx';
  static readonly EMG_DATA_RX: string = 'emg:data:rx';
  static readonly EMG_DISCONNECTED: string = 'emg:disconnected';
  static readonly THERM_CONNECTED: string = 'therm:connected';
  static readonly THERM_LISTENING: string = 'therm:listening';
  static readonly THERM_STATUS_RX: string = 'therm:status:rx';
  static readonly THERM_CONFIG_RX: string = 'therm:config:rx';
  static readonly THERM_DATA_RX: string = 'therm:data:rx';
  static readonly THERM_DISCONNECTED: string = 'therm:disconnected';
  static readonly HRV_CONNECTED: string = 'hrv:connected';
  static readonly HRV_LISTENING: string = 'hrv:listening';
  static readonly HRV_STATUS_RX: string = 'hrv:status:rx';
  static readonly HRV_CONFIG_RX: string = 'hrv:config:rx';
  static readonly HRV_DATA_RX: string = 'hrv:data:rx';
  static readonly HRV_DISCONNECTED: string = 'hrv:disconnected';
  static readonly DEVICE_CONNECTED: string = 'device:connected';
  static readonly DEVICE_LISTENING: string = 'device:listening';
  static readonly LOGS_SENT: string = 'logs:sent';
}

export class ClaStorage {
  static readonly APP_PREVIOUS_BOX_ID:string = 'app:previousboxid';
  static readonly APP_LOGIN_TOKEN:string = 'access_token';
  static readonly APP_OFFLINE_STAMP:string = 'app:offlinestamp';
  static readonly APP_WALKTHROUGH_DONE: string = 'walkthrough:complete';
  static readonly APP_SWIPE_WALKTHROUGH_DONE: string = 'walkthrough:swipe:complete';
  static readonly BETA_ACCEPTED: string = 'beta:accepted';
  static readonly TERMS_ACCEPTED: string = 'terms:accepted';
  static readonly APP_SOUNDS_STATE: string = 'app:sounds';
  static readonly APP_SERVER_USE: string = 'app:server';
  static readonly KEYCHAIN_ENABLED: string = 'keychain:enabled';
  static readonly THERMAL_ROLLING_SETTING: string = 'app:thermal:rolling';
  static readonly BLE_GEAR: string = 'app:ble:gear';
  static readonly ALL_BLE_GEAR: string = 'app:all:ble:gear';
  static readonly BLUETOOTH: string = 'app:bluetooth';
  static readonly LOGIN_HASH: string = 'app:login:hash';
  static readonly PRACTICE_OFFLINE: string = 'app:practice:offline';
}

export class ClaBridgeVersions {
  // introduced ability to redo thermal rolling C1 readings
  static readonly VER_1_2019_4011:string = '1.2019.4011.0';
}
export enum BoxStatus {
  UNKNOWN,
  CONNECTING,
  ONLINE_ALL,
  ONLINE_AZURE,
  ONLINE_LOCAL,
  OFFLINE_ALL,
  BRIDGELESS_MODE
}

export class ClaAudio {
  static readonly FEMALE: string = 'female';
  static readonly MALE: string = 'male';
  static readonly NONE: string = 'none';

  static readonly BEGIN_SCAN: string = 'audio:beginscan';
  static readonly C1: string = 'audio:c1';
  static readonly C2: string = 'audio:c2';
  static readonly C3: string = 'audio:c3';
  static readonly C4: string = 'audio:c4';
  static readonly C5: string = 'audio:c5';
  static readonly C6: string = 'audio:c6';
  static readonly C7: string = 'audio:c7';
  static readonly T1: string = 'audio:t1';
  static readonly T2: string = 'audio:t2';
  static readonly T3: string = 'audio:t3';
  static readonly T4: string = 'audio:t4';
  static readonly T5: string = 'audio:t5';
  static readonly T6: string = 'audio:t6';
  static readonly T7: string = 'audio:t7';
  static readonly T8: string = 'audio:t8';
  static readonly T9: string = 'audio:t9';
  static readonly T10: string = 'audio:t10';
  static readonly T11: string = 'audio:t11';
  static readonly T12: string = 'audio:t12';
  static readonly L1: string = 'audio:l1';
  static readonly L2: string = 'audio:l2';
  static readonly L3: string = 'audio:l3';
  static readonly L4: string = 'audio:l4';
  static readonly L5: string = 'audio:l5';
  static readonly S1: string = 'audio:s1';
  static readonly S2: string = 'audio:s2';
  static readonly S3: string = 'audio:s3';
  static readonly S4: string = 'audio:s4';
  static readonly S5: string = 'audio:s5';
  static readonly LEFT: string = 'audio:left';
  static readonly RIGHT: string = 'audio:right';
  static readonly CLICK: string = 'audio:click';

}



// WEBPACK FOOTER //
// ./src/model/events.ts